import { Container } from "react-bootstrap";
import "../style/home.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
export default function Home(){
  const navigate = useNavigate();
  const [activeLink, setActiveLink] = useState(""); // حالة لتخزين الرابط النشط

  const handleClick = (e, path) => {
    e.preventDefault(); // منع إعادة تحميل الصفحة
    setActiveLink(path); // تحديث المسار النشط
    navigate(path); // التنقل باستخدام React Router
  };
    return(
       <div className="Home-section">
  <div className="darck-box">
  <Container>
     
     <div className="home-content">
                <h5>Hochwertige Reinigung zum fairen Preis.</h5>
              <h2>Spezialisierte, effiziente <br/> und gründliche <br/>Reinigungsdienste</h2>
              <p>Wir bieten die Durchführung von Reinigungsaufgaben mit minimalem Zeit-,<br/> Energie- und Kostenaufwand.</p>
              <div className="home-btn">
                <button onClick={(e) => handleClick(e, "/contact")} className="home-btn-close">Beginnen Sie jetzt</button>
                <button onClick={(e) => handleClick(e, "/service")} className="home-btn-open">Alle Dienste anzeigen</button>
              </div>
            </div>
     
        </Container>
  </div>
       </div>
    );
}